import { useTranslation } from "react-i18next";
import type { SkillScope } from "@/hooks/use-skills";
import { cn } from "@/lib/utils";

const styles: Record<SkillScope, string> = {
  user: "bg-blue-100 text-blue-700 dark:bg-blue-900/30 dark:text-blue-300",
  tenant:
    "bg-amber-100 text-amber-700 dark:bg-amber-900/30 dark:text-amber-300",
  system:
    "bg-slate-100 text-slate-600 dark:bg-slate-800/40 dark:text-slate-400",
};

export function ScopeBadge({ scope }: { scope: SkillScope }) {
  const { t } = useTranslation();

  return (
    <span
      className={cn(
        "inline-flex shrink-0 items-center rounded-full px-2 py-0.5 text-[11px] font-medium",
        styles[scope],
      )}
    >
      {t(`settings.skills.scope.${scope}`)}
    </span>
  );
}
